module.exports = __webpack_public_path__ + "static/media/folha3.b1b69b1a.png";